import React from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import { Icon } from 'antd';
import styles from './BackBtn.module.scss';

const BackBtn = ({ className, link }) => {
  return (
    <Link to={link} className={cn(styles.button, className)}>
      <Icon type="left" />
    </Link>
  );
};

export default BackBtn;
